import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatError } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { MatInput } from '@angular/material/input';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'billing-ui-memo',
  templateUrl: './memo.component.html',
  styleUrls: ['./memo.component.scss'],
  imports: [MatCard, MatCardContent, GalaxyFormFieldModule, MatError, ReactiveFormsModule, TranslateModule, MatInput],
})
export class MemoComponent implements OnInit {
  @Input() readOnly = false;
  @Input() existingMemo: string;
  @Input() memoSubtitle: string;
  @Output() memoControlChanges = new EventEmitter<FormControl>();

  memoControl: FormControl<string>;
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.memoControl = new FormControl(this.existingMemo ?? null, [Validators.maxLength(500)]);

    this.memoControl.valueChanges.pipe(debounceTime(400), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.memoControlChanges.emit(this.memoControl);
    });
  }
}
